import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 진정형 그라운딩 조회
export function getGroundingCalmingFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/grounding/calming',
        method: 'get',
        params: {pid}
    })
}

// 주차별 가장 편안하다고 느낀 방법 조회
export function getGroundingComfortableFromMomthera({pid, sessionNum}) {
    return AxiosInterceptor({
        url: '/grounding/comfortable',
        method: 'get',
        params: { pid, 'session-num': sessionNum }
    })
}